import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="Contenuto del protocollo" className="bg-transparent" data-id="element-183" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-184" data-mp="1c5gr7r0f2dw9">
        <div className="text-center" data-id="element-185" data-mp="1zvb1q1x9jqdc">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-186" data-mp="1zwcq183ai9d0">
            🏥 PROTOCOLLO ATLETA 360: IL SISTEMA VISIVO
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-187" data-mp="1qud72a8psv7f">
            📚 Il Metodo Clinico in 6 Volumi
          </h2>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-188" data-mp="1vs4yl35g6fb3">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum-soft" data-id="element-189" data-mp="fe6evwqtm7mk">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-190" data-mp="3o8f189k3z7mf">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-grape/15 bg-white p-5" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-191" data-mp="3jan0qr5eed6m" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-192" data-mp="60piq8kkllvv">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lilac-soft font-display text-lg font-black text-grape" data-id="element-193" data-mp="kq4yktikc6ws">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-194" data-mp="tq1sb9jt7vyp">
                  <span aria-hidden="true" data-id="element-195" data-mp="prud4j4zv2pm">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-196" data-mp="wrmsdxfo15ph">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-197" data-mp="16s6wd7ukkobe">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-198" data-mp="16q2fzqfhhwu8">
            ✅ Ogni volume include:
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-199" data-mp="1fkqn7m4mdolo">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-200" data-mp="1kisdos4dkq76">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-201" data-mp="1piobg9mhblea" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}